import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App, { HydrateAtoms } from './App.tsx';
import { Provider } from 'jotai';
import { store } from './store/index.ts';
import { queryClient } from './clients/queryClient.ts';
import { QueryClientProvider } from '@tanstack/react-query';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './services/azureAuthService.ts';
import {
  rootErrorHandlers,
  installGlobalErrorHandlers,
} from './services/crashRecovery.ts';

// Initialize MSAL before rendering the app
async function initializeApp() {
  try {
    // Initialize MSAL instance
    await msalInstance.initialize();
    console.log('MSAL initialized successfully');
  } catch (error) {
    console.error('Failed to initialize MSAL:', error);
  }

  // Record errors globally (complements OpenReplay's remote capture with a local,
  // offline-exportable buffer) and show a recovery overlay on a fatal render crash.
  installGlobalErrorHandlers();

  // Now render the app
  createRoot(document.getElementById('root')!, rootErrorHandlers).render(
    <StrictMode>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <HydrateAtoms>
              <App />
            </HydrateAtoms>
          </Provider>
        </QueryClientProvider>
      </MsalProvider>
    </StrictMode>,
  );
}

// Start the initialization
initializeApp();
